import api from '@pray/shared/utils/api';

export async function createLeadCampaign({
  name,
  title,
  subtitle,
  disclaimer,
  buttonText,
  imageUrl,
  type,
  targetCount,
  allocationMode,
  autopopulatePhoneNumber,
  leadClientId,
  scheduledStartDate,
  scheduledEndDate,
  dailyTargetLimit,
  popupEnabled,
  adUnitDescription,
  adUnitButtonText,
  placements,
  platforms,
  offerId,
  ctaDestination,
}) {
  if (!name) throw Error('Name is required');
  if (!title) throw Error('Title is required');
  if (!subtitle) throw Error('Description is required');
  if (!buttonText) throw Error('Button text is required');
  if (!type) throw Error('Type is required');
  // An open-ended campaign has no target by definition, so only demand one from a targeted campaign.
  const isOpenEnded = allocationMode === 'open_ended';
  if (!isOpenEnded && !targetCount) throw Error('Target count is required');

  // Explicit null, never an omitted key. `undefined` is dropped on serialization and the column
  // defaults to 0, which would record the campaign as working toward zero leads: the same
  // misstatement as the all-nines sentinel, just quieter.
  const normalizedTargetCount = isOpenEnded ? null : targetCount;
  if (!leadClientId) throw Error('Organization is required');
  if (!scheduledStartDate) throw Error('Start date is required');

  const data = {
    name,
    title,
    subtitle,
    button_text: buttonText,
    type,
    target_count: normalizedTargetCount,
    lead_client_id: leadClientId,
    scheduled_start_date: scheduledStartDate,
    daily_target_limit: dailyTargetLimit,
  };

  if (disclaimer) data.disclaimer = disclaimer;
  if (imageUrl) data.image_url = imageUrl;
  if (autopopulatePhoneNumber) data.auto_populate_phone_number = autopopulatePhoneNumber;
  if (scheduledEndDate) data.scheduled_end_date = scheduledEndDate;
  if (popupEnabled !== undefined) data.popup_enabled = popupEnabled;
  if (adUnitButtonText) data.ad_unit_button_text = adUnitButtonText;
  if (adUnitDescription) data.ad_unit_description = adUnitDescription;
  if (Array.isArray(placements)) data.placements = placements;
  if (Array.isArray(platforms)) data.platforms = platforms;
  if (offerId) data.offer_id = offerId;
  if (allocationMode !== undefined) data.allocation_mode = allocationMode;
  // Where a link campaign's button goes. Only ever sent for one: the server refuses a destination on an email
  // campaign, and a server that predates link campaigns refuses the key outright.
  if (ctaDestination) data.cta_destination = ctaDestination;

  const url = `/web/studio/lead-campaigns`;
  const response = await api.executePostRequest(url, data);

  return response.data;
}
